import type { TabProps, TabsProps } from "@mui/material";
import { Tabs, styled } from "@mui/material";

import { DARK_BLUE } from "theme/colors";

interface MUITabsProps extends TabsProps {
  children: (React.ReactElement<TabProps> | false | null | undefined)[];
}

export const MUITabs: React.FC<MUITabsProps> = ({ children, ...props }) => {
  return <StyledTabs {...props}>{children}</StyledTabs>;
};

const StyledTabs = styled(Tabs)<TabsProps>(({ theme }) => ({
  minHeight: "43px",

  "& .MuiTab-root": {
    minHeight: "42px",
    fontSize: "14px",
    fontWeight: 400,
    color: DARK_BLUE[70],
    borderBottom: `1px solid ${theme.palette.divider}`,

    "&:hover, &.Mui-selected": {
      color: theme.palette.custom.accent,
    },
  },

  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.custom.accent,
    height: 1,
  },
}));
